import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const NAV_ITEMS = [
  { label: "首页", to: "/", end: true },
  { label: "电视剧", to: "/category/tv" },
  { label: "电影", to: "/category/movie" },
  { label: "热门推荐", to: "/category/hot" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="px-4 md:px-6 h-16 flex items-center gap-6">
        <Link
          to="/"
          className="flex items-center gap-2 shrink-0 cursor-pointer"
          aria-label="激情丛林首页"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-leaf-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading font-extrabold text-lg tracking-tight text-foreground-950">
            激情丛林
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 flex-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `px-3.5 py-2 rounded-md text-sm font-semibold whitespace-nowrap transition-colors ${
                  isActive
                    ? "text-primary-700 bg-primary-50"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block w-64 lg:w-72 shrink-0">
          <SearchBox variant="header" />
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer transition-colors hover:bg-background-100"
          aria-label="打开菜单"
          aria-expanded={menuOpen}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 animate-fade-in">
          <div className="py-3">
            <SearchBox variant="page" />
          </div>
          <nav className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3.5 py-2.5 rounded-md text-sm font-semibold transition-colors ${
                    isActive
                      ? "text-primary-700 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}